import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewRindePorDestino = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'rela_destino_rinde',
        name: 'Rinde por destino',
        component: ViewRindePorDestino,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
